import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
}), 'SignalCellularConnectedNoInternet4BarTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellularConnectedNoInternet4BarTwoTone.js
// module id = 6187
// module chunks = 2